import { render, staticRenderFns } from "./LeaderboardPrevMonthRetsRenderer.vue?vue&type=template&id=7006fe11&"
import script from "./LeaderboardPrevMonthRetsRenderer.vue?vue&type=script&lang=js&"
export * from "./LeaderboardPrevMonthRetsRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports